import {axiosInstance} from "../helpers/axios";

const getPurchaseDetail = (data) => {
    return axiosInstance.post('getPurchaseDetail/', data ).then((res) => {
        const data = res.data;
        return data;
    }).
    catch(err => {
        console.log("error");
        console.log(err.message);
    });
}

export default { getPurchaseDetail };